export default "__VITE_ASSET__BTYwdJBT__"